<template>
  <LayoutDefault>
    <template #content>
      <slot />
    </template>
  </LayoutDefault>
</template>
